import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import DrawerPwa from '../DrawerPwa';
import DialogBox from '../DialogBox';
import { Redux, Slices } from 'spwa-ui-library';
import { useIntl } from 'react-intl';
import css from './index.module.scss';
import noImg from '../../assets/no-itm.png';
const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;

function ConfirmDeleteDialog({ setShowConfirmDeleteDialog, handleDelete, thumbnail }) {
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);

  const handlePopupClose = () => {
    setShowConfirmDeleteDialog(false);
  };

  const deleteItem = () => {
    handleDelete();
    setShowConfirmDeleteDialog(false);
    localStorage.removeItem('isBackNotPressed');
  };

  const DialogContent = (
    <Grid>
      <div className={css.removeItemImg}>
        <img
          src={thumbnail}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImg;
          }}
        />
      </div>
      <div className={css.removeItemBody}>
        <Typography variant="body1">
          {intl.formatMessage({ id: 'remove_item_cart_body' })}
        </Typography>
      </div>
      <div className={css.removeItemFooter}>
        <Button
          variant={'outlined'}
          color={'secondary'}
          onClick={() => {
            setShowConfirmDeleteDialog(false);
          }}
        >
          {intl.formatMessage({ id: 'cart_cancel', defaultMessage: 'Cancel' })}
        </Button>
        <Button
          variant={'outlined'}
          color={'primary'}
          onClick={() => {
            deleteItem();
          }}
        >
          {intl.formatMessage({ id: 'cart_confirm', defaultMessage: 'Yes, Confirm' })}
        </Button>
      </div>
    </Grid>
  );

  return (
    <>
      {isDesktop ? (
        <DialogBox
          title={intl.formatMessage({ id: 'remove_item' })}
          titleClass={css.removeItemTitle}
          hideCloseButton={true}
          size="md"
          className={css.confirmDeleteDialog}
          isOpen={true}
          onClose={() => {
            handlePopupClose();
          }}
        >
          {DialogContent}
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          hideCloseButton={true}
          extraClass={css.showConfirmDeleteDrawer}
          open={true}
          onClose={() => {
            handlePopupClose();
          }}
        >
          {DialogContent}
        </DrawerPwa>
      )}
    </>
  );
}

export default ConfirmDeleteDialog;
